import { isMockServices } from 'src/utils';
import mock from 'src/services/utils/mock';
import { MutationFunction } from '@tanstack/react-query';
import { getCompatibleAuthTokenHttp } from '../utils/enhancedAuthTokenHttp';

export interface CreateInvitationParams {
  email: string;
  tenantId: string;
  role: string;
}

const createInvitation: MutationFunction<
  { success: boolean },
  CreateInvitationParams
> = async (args) => {
  if (isMockServices()) return await mock(_mockType);
  const authTokenHttp = await getCompatibleAuthTokenHttp();
  const response = await authTokenHttp<{ success: boolean }>(
    `/shared/invites`,
    {
      method: 'POST',
      body: {
        ...args,
      },
    },
  );
  if (response.data) return response.data;
  throw new Error('Failed to create invitation');
};

export default createInvitation;

const _mockType = {
  success: true,
};
